import React, { Component, Fragment } from 'react';
import './chat.css';
import DateTimeManager from './../Common/DateTimeManager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faFlag, faShare } from '@fortawesome/free-solid-svg-icons'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import axios from 'axios';
import SignalRController from '../SignalRController';
import ChatContext from './../context/ChatContext';

const DragHandle = sortableHandle(() => <span className="dragHandle">||</span>);

const SortableContainer = sortableContainer(({ children }) => {
    return (
        <ul className="nodots">
            {children}
        </ul>
    )
});

export class SortableChatCard extends Component {

    constructor(props) {
        super(props);

        this.state = {
            chats: this.props.chatItems,
            inbox: this.props.inbox,
            messagesSorted: [],
            listUpdated: false,
            forceUpdate: false
        }
    }

    componentDidMount() {
        let chatItems = [];
        this.props.chatItems.map((chat) => {
            let chatObject = Object.assign({}, chat);
            chatObject['Id'] = chat.messageId;
            chatItems.push(chatObject)
        });

        this.setState({
            messagesSorted: chatItems
        })

        this.onUpdate = this.onUpdate.bind(this);

    }

    componentDidUpdate(prevProps) {

        // Problems with refreshing and setting stats - so compare previous props to this to see if refresh valued

        let changedProps = false;
        //quickest check is to see if the number of items has changed
        if (this.props.chatItems.length != prevProps.chatItems.length) changedProps = true;
        else {
            // 2nd check add things in here that change but don't affect the array size but that also need to refresh the screen (such as items marked as answered)
            let prevAnswered = "";
            let nowAnswered = "";
            prevProps.chatItems.map((chat) => prevAnswered += chat.answered);
            this.props.chatItems.map((chat) => nowAnswered += chat.answered);
            if (prevAnswered != nowAnswered) changedProps = true;
        }

        if (changedProps == true) {
            let chatItems = [];

            this.props.chatItems.map((chat) => {
                var chatObject = Object.assign({}, chat);
                chatObject['Id'] = chat.messageId;
                chatItems.push(chatObject)
            });

            this.setState({
                forceUpdate: false,
                messagesSorted: chatItems
            })
        }
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({
            messagesSorted: arrayMove(this.state.messagesSorted, oldIndex, newIndex),
            listUpdated: true
        }));

    };

    onUpdate() {
        let SortedList = '';
        this.state.messagesSorted.forEach((chat) => SortedList = SortedList + chat.messageId + ';');

        axios.post(`api/UpdateMessageOrder`, { VMeetingId: this.props.VMeetingId, SortOrder: SortedList, inbox: this.props.inbox }).then(res => {
            this.setState({ listUpdated: false });
            //SignalRController.InvokeAdm2Adm_MessageUpdate();
        })

    }

    render() {
        if (this.props.chatItems && this.props.chatItems.length < 1) return (<div>Mailbox Empty</div>);
        let inbox = this.props.inbox;
        const { authFunc } = this.props;

        return (
            <div>
                {this.state.listUpdated && this.props.isAuthorized && <button className="btn updateMsgButton" onClick={this.onUpdate}>Update</button>}
                <SortableContainer onSortEnd={this.onSortEnd} useDragHandle>
                    {

                        this.state.messagesSorted.map((chat, i) => {
                            const SortableItem = sortableElement((chat) =>
                                <li>
                                    <div key={chat.value.messageId + '_' + chat.value.attendeeId + '_'} className="grid-container" >
                                        <div className="Status" onClick={this.props.respond ? () => this.props.respond(chat.value, inbox, this.props.type) : null}>
                                            <DragHandle />
                                        </div>
                                        {
                                            this.props.hideClose || !this.props.isAuthorized ? <div /> :
                                                <div disabled={!this.props.isAuthorized} className="Close" key={chat.value.messageId + "_" + this.props.inbox} onClick={this.props.removeChatFromInbox ? () => this.props.removeChatFromInbox(chat.value, this.props.inbox) : null}>&times;</div>
                                        }
                                        <div className={"Title-Bar inbox" + inbox} onClick={this.props.respond ? () => this.props.respond(chat.value, inbox, this.props.type) : null}>
                                            {chat.value.messageDirection == 0 ? <span>From: </span> : <span>To: </span>}
                                            {chat.value.attendeeName ? chat.value.attendeeName : <span>User ID: {chat.value.attendeeId}</span>}

                                            {chat.value.passedBack > 0 ?
                                                <span className="ignoredFlag"><FontAwesomeIcon icon={faFlag} /></span> : <span />
                                            }
                                            {
                                                chat.value.answered > 0 ?
                                                    <span className="answeredFlag"><FontAwesomeIcon icon={faFlag} /></span> : <span />
                                            }

                                            {
                                                chat.value.messageDateTime
                                                &&
                                                this.props.presenter
                                                &&
                                                (authFunc('InboxPres', 'Write'))
                                                &&
                                                <div className="ignoreButtonHolder">
                                                    {
                                                        typeof (this.props.ignore) === "function" ?
                                                            <button disabled={!this.props.isAuthorized} className="ignore btn" title="Return to admin" aria-label="Return to admin" onClick={(e) => this.props.ignore(e, chat.value)}>
                                                                <FontAwesomeIcon icon={faShare} />
                                                            </button> : null
                                                    }
                                                    {
                                                        typeof (this.props.answered) === "function" && chat.value.answered < 1 ?
                                                            <button disabled={!this.props.isAuthorized} className="answered btn" title="Confirm answered" aria-label="Confirm answered" onClick={(e) => { this.props.answered(e, chat.value); this.setState({ forceUpdate: true }) }}>
                                                                <FontAwesomeIcon icon={faCheck} />
                                                            </button> : null
                                                    }
                                                </div>
                                            }
                                        </div>
                                        <div className="Message" onClick={this.props.respond ? () => this.props.respond(chat.value, inbox, this.props.type) : null}>{chat.value.messageText}</div>
                                        <div className="Time" onClick={this.props.respond ? () => this.props.respond(chat.value, inbox, this.props.type) : null}> {new DateTimeManager(chat.value.messageDateTime).getTimeDefaultFormat()} </div>

                                        {chat.value.messageNotes ?
                                            <div className="ModeratorMessage">{chat.value.messageNotes}</div>
                                            : null}
                                    </div>
                                </li>
                            );

                            return (<SortableItem key={'item-' + chat.messageId + '-' + 'inbox'} index={i} value={chat} disabled={!this.props.isAuthorized} />)


                        })
                    }
                </SortableContainer>
            </div>
        )
    }
}
SortableChatCard.contextType = ChatContext;

export default SortableChatCard
